import footerLogo from "../assets/footerLogo.png";
function Footer(props) {
  return (
    <div className="footer">
      <img src={footerLogo} alt="logo" />
    </div>
  );
}

export default Footer;
